import React, { useState } from 'react'
import {
    Dialog,
    DialogContent,
    DialogTitle,
    MenuItem,
    Select,
    Button,
    makeStyles,
} from '@material-ui/core'
import { withTranslation } from 'react-i18next'
import customConstants from '../../../Constants'

const useStyles = makeStyles((theme) => ({
    dialog: {
        backgroundColor: '#fff',
        padding: theme.spacing(2),
    },
    dialogTitle: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: '#333',
    },
    select: {
        marginBottom: theme.spacing(2),
        color: '#333',
    },
    inputRoot: {
        '& .MuiOutlinedInput-input': {
            backgroundColor: '#f9f9f9',
            padding: '12px',
            borderRadius: 4,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9F71BD',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#7e5a99',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9F71BD',
        },
    },
    selectIcon: {
        color: '#9F71BD',
    },
    actions: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: theme.spacing(2),
    },
    cancelButton: {
        'backgroundColor': theme.palette.grey[500],
        'color': theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.grey[700],
        },
    },
    confirmButton: {
        'backgroundColor': '#9F71BD',
        'color': theme.palette.common.white,
        '&:hover': {
            backgroundColor: '#7e5a99',
        },
        '&:disabled': {
            backgroundColor: '#cecece !important',
            color: '#fff !important',
        },
    },
}))

function VideoCallAgentDialog({ open, onClose, t, history }) {
    const classes = useStyles()
    const options = customConstants.getVideoCallProviderOptions()
    const [selectedAgent, setSelectedAgent] = useState('')

    const handleAgentSelection = () => {
        if (selectedAgent) {
            localStorage.setItem('videoCallProvider', selectedAgent)
            localStorage.setItem('videoCallAgent', selectedAgent)
            onClose()
            history.push('/calls/video_call')
        }
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth={'sm'} classes={{ paper: classes.dialog }}>
            <DialogTitle className={classes.dialogTitle}>
                {t('Select Video Call Partner')}
            </DialogTitle>
            <DialogContent>
                <Select
                    value={selectedAgent}
                    onChange={(e) => setSelectedAgent(e.target.value)}
                    fullWidth
                    displayEmpty
                    className={classes.select}
                    classes={{
                        root: classes.inputRoot,
                        icon: classes.selectIcon,
                    }}
                >
                    <MenuItem value="" disabled>
                        {t('Select an option')}
                    </MenuItem>
                    {options.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {t(option.label)}
                        </MenuItem>
                    ))}
                </Select>
                <div className={classes.actions}>
                    <Button onClick={onClose} className={classes.cancelButton}>
                        {t('Cancel')}
                    </Button>
                    <Button
                        onClick={handleAgentSelection}
                        className={classes.confirmButton}
                        disabled={!selectedAgent}
                    >
                        {t('Confirm')}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default withTranslation()(VideoCallAgentDialog)
